import { toNumber, isNil, map } from 'lodash'

export default {
    // to be deleted after builder rework
    getParentJsonKeyName: (type, val) => {
        if (type === 'taxonomy') {
            return null
        } else if (type === 'segment') {
            return 'segment_wb_gt'
        } else if (type === 'cluster') {
            if (isNil(val.bigsea_segment_id)) {
                return 'segment_' + val.owner + '_' + val.taxonomy
            } else {
                return 'segment_' + val.bigsea_segment_id
            }
        }
    },

    buildJsonKey: (type, val, countryCode2) => {
        return {
            name: type === 'segment' || type === 'cluster' ? type + '_' + val.id : 'segment_' + val.owner + '_' + val.taxonomy,
            type: type === 'segment' || type === 'taxonomy' ? 'Segment' : 'Cluster',
            subType: null,
            ids: type === 'taxonomy' ? [val.owner + '_' + val.taxonomy, countryCode2] : [toNumber(val.id), countryCode2]
        }
    },

    getSmartSegmentIds: smartSegments => {
        if (isNil(smartSegments)) return []
        return map(smartSegments, smartSegmemt => {
            return smartSegmemt.id
        })
    }
}
